import { memo } from 'react';
import { ShopDetailTabs } from './ShopDetailTabs';
import { getPageInfo } from '@/config/pages';
import {
  BrandObject,
  ShopObject
} from '@/graphql/generated/graphql';

type ActiveIndex = 1 | 2 | 3 | 4 | 5;

type ShopDetailNavigationProps = {
  shop: Pick<ShopObject, 'slug' | 'name'>;
  currentPage: ActiveIndex;
  brand?: NonNullable<BrandObject> | null | undefined;
  isNullCourseFromShop: boolean;
  isNullStaffsFromShop: boolean;
  isNullMessageFromShop: boolean;
  isNullBlogFromShop: boolean;
}

export const ShopDetailNavigation = memo(({
  shop,
  currentPage,
  isNullCourseFromShop,
  isNullStaffsFromShop,
  isNullMessageFromShop,
  isNullBlogFromShop
}: ShopDetailNavigationProps) => {

  return (
    <ShopDetailTabs
      activeIndex={currentPage - 1}
      isNullCourseFromShop={isNullCourseFromShop}
      isNullStaffsFromShop={isNullStaffsFromShop}
      isNullMessageFromShop={isNullMessageFromShop}
      isNullBlogFromShop={isNullBlogFromShop}
      shopDetailLinks={
        [
          {
            menuLink: getPageInfo('studio/{slug}', shop),
            tabMenuTitle: '店舗情報',
            tabIcon: '/images/detail_page_icon/store_icon.png',
            activeTabIcon: '/images/detail_page_icon/store_icon_active.png',
            spTabIcon: '/images/detail_page_icon/store_icon_sp.png',
            spActiveTabIcon: '/images/detail_page_icon/store_icon_active_sp.png',
            tabIconAlt: '店舗情報'
          },
          {
            menuLink: getPageInfo('studio/{slug}/menu', shop),
            tabMenuTitle: 'メニュー',
            tabIcon: '/images/detail_page_icon/course_icon.png',
            activeTabIcon: '/images/detail_page_icon/course_icon_active.png',
            spTabIcon: '/images/detail_page_icon/course_icon_sp.png',
            spActiveTabIcon: '/images/detail_page_icon/course_icon_active_sp.png',
            tabIconAlt: 'メニュー'
          },
          {
            menuLink: getPageInfo('studio/{slug}/staff', shop),
            tabMenuTitle: 'スタッフ',
            tabIcon: '/images/detail_page_icon/staff_icon.png',
            activeTabIcon: '/images/detail_page_icon/staff_icon_active.png',
            spTabIcon: '/images/detail_page_icon/staff_icon_sp.png',
            spActiveTabIcon: '/images/detail_page_icon/staff_icon_active_sp.png',
            tabIconAlt: 'スタッフ'
          },
          {
            menuLink: getPageInfo('studio/{slug}/message', shop),
            tabMenuTitle: 'お店からのメッセージ',
            tabIcon: '/images/detail_page_icon/message_icon.png',
            activeTabIcon: '/images/detail_page_icon/message_icon_active.png',
            spTabIcon: '/images/detail_page_icon/message_icon_sp.png',
            spActiveTabIcon: '/images/detail_page_icon/message_icon_active_sp.png',
            tabIconAlt: 'お店からのメッセージ'
          },
          {
            menuLink: getPageInfo('studio/{slug}/blog', shop),
            tabMenuTitle: '店舗ブログ',
            tabIcon: '/images/detail_page_icon/blog_icon.png',
            activeTabIcon: '/images/detail_page_icon/blog_icon_active.png',
            spTabIcon: '/images/detail_page_icon/blog_icon_sp.png',
            spActiveTabIcon: '/images/detail_page_icon/blog_icon_active_sp.png',
            tabIconAlt: '店舗ブログ'
          },
        ]
      }
    />
  );
}
);
ShopDetailNavigation.displayName = 'ShopDetailNavigation';
